<script setup>
import { Volume1, VolumeOff, Copy, Check } from 'lucide-vue-next'
import { useSpeechSynthesis, useClipboard } from '@vueuse/core'
import { useWidget } from '@/widget'
import { stripMarkdown } from '@/converter'
import { useTranslations } from '@/translation'
import { computed } from 'vue'
const props = defineProps({
  isBot: Boolean,
  index: Number,
  message: {
    sender: String,
    content: String,
    bot: Boolean,
    time: Date
  }
})
const { voiceOptions } = useWidget()
const { t } = useTranslations()
const {
  copy,
  copied,
  isSupported: isClipboardSupported
} = useClipboard({ source: props.message.content })
const messageRaw = computed(() => stripMarkdown(props.message.content) || '')

const { speak, isPlaying, stop, isSupported } = useSpeechSynthesis(messageRaw.value, {
  ...voiceOptions
})
const handleCopy = () => {
  copy(messageRaw.value)
  setTimeout(() => {
    copied.value = false
  }, 2000)
}
const handleRead = () => {
  if (isPlaying.value) {
    stop()
  } else {
    speak({ text: messageRaw.value })
  }
}
</script>

<template>
  <div class="ml-2 flex items-center justify-between my-2 gap-2">
    <button
      v-if="isSupported"
      type="button"
      @click="handleRead"
      :aria-label="isPlaying ? t('aria.stopSpeech') : t('aria.startSpeech')"
      :aria-pressed="isPlaying"
      v-tooltip="isPlaying ? t('buttons.stopSpeech') : t('buttons.startSpeech')"
    >
      <component :is="isPlaying ? VolumeOff : Volume1" class="text-primary" :size="16" />
    </button>
    <button
      v-if="isClipboardSupported"
      type="button"
      @click="handleCopy"
      :aria-label="copied ? t('aria.copied') : t('aria.copyToClipboard')"
      v-tooltip="copied ? t('buttons.copied') : t('buttons.copy')"
    >
      <component :is="copied ? Check : Copy" :size="16" />
    </button>
  </div>
</template>
